import React from "react";
import { Link } from "react-router-dom";
import { Download, Globe, Smartphone } from "lucide-react";
import { APP_STORE_URL, IS_APP_STORE_LIVE } from "../config/appLinks";

const badgeClass =
  "w-32 transition-transform duration-300 group-hover:scale-[1.04] sm:w-36";

const storeBadgeClass =
  "group inline-flex h-10 w-32 items-center justify-center gap-2 rounded-lg border px-2.5 text-white shadow-sm transition-transform duration-300 hover:scale-[1.04] sm:h-11 sm:w-36 sm:px-3";

const androidBadgeClass = `${storeBadgeClass} border-[#3DDC84]/40 bg-[#0d1117] hover:border-[#3DDC84]/70`;

const iphoneWebBadgeClass = `${storeBadgeClass} border-white/20 bg-[#111827] hover:border-white/35`;

const webButtonClass =
  "inline-flex h-10 min-w-[8rem] items-center justify-center gap-2 rounded-lg border border-[#64B5F6]/50 bg-gradient-to-b from-[#1E88E5] to-[#1565C0] px-4 text-sm font-extrabold tracking-tight text-white shadow-[0_6px_18px_-8px_rgba(30,136,229,0.75)] transition-all hover:brightness-110 sm:h-11 sm:min-w-[9rem]";

function AndroidApkButton({ tooltipId }) {
  return (
    <Link
      to="/download"
      className={androidBadgeClass}
      data-tooltip-id={tooltipId}
      aria-label="Download BetBond APK for Android"
    >
      <Download size={18} className="shrink-0 text-[#3DDC84]" aria-hidden />
      <span className="text-left leading-tight">
        <span className="block text-[9px] font-medium uppercase tracking-wide text-white/60 sm:text-[10px]">
          Official
        </span>
        <span className="block text-[11px] font-bold sm:text-xs">Android APK</span>
      </span>
    </Link>
  );
}

function AppStoreButton({ tooltipId }) {
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="group"
      data-tooltip-id={tooltipId}
      aria-label="Download BetBond on the App Store"
    >
      <img
        src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
        alt="Download on the App Store"
        className={badgeClass}
      />
    </a>
  );
}

function IphoneWebButton({ tooltipId }) {
  return (
    <Link
      to="/app/welcome"
      className={iphoneWebBadgeClass}
      data-tooltip-id={tooltipId}
      aria-label="Use BetBond on iPhone in your browser"
    >
      <Smartphone size={18} className="shrink-0 text-[#64B5F6]" aria-hidden />
      <span className="text-left leading-tight">
        <span className="block text-[9px] font-medium uppercase tracking-wide text-white/60 sm:text-[10px]">
          iPhone
        </span>
        <span className="block text-[11px] font-bold sm:text-xs">Open web app</span>
      </span>
    </Link>
  );
}

function WebAppButton({ tooltipId }) {
  return (
    <Link
      to="/app/welcome"
      className={webButtonClass}
      data-tooltip-id={tooltipId}
      aria-label="Open BetBond web app"
    >
      <Globe size={16} strokeWidth={2.3} aria-hidden />
      <span>Open web app</span>
    </Link>
  );
}

/**
 * iOS (App Store when live, otherwise web) + Android APK + web app.
 */
export default function AppDownloadButtons({
  showTooltips = false,
  className = "",
}) {
  const appleTip = showTooltips ? "apple-tooltip" : undefined;
  const androidTip = showTooltips ? "android-tooltip" : undefined;
  const webTip = showTooltips ? "web-tooltip" : undefined;

  return (
    <div
      className={`flex flex-row flex-wrap items-center justify-center gap-3 sm:gap-4 ${className}`}
    >
      {IS_APP_STORE_LIVE ? (
        <AppStoreButton tooltipId={appleTip} />
      ) : (
        <IphoneWebButton tooltipId={appleTip} />
      )}
      <AndroidApkButton tooltipId={androidTip} />
      <WebAppButton tooltipId={webTip} />
    </div>
  );
}
